module.exports = __webpack_public_path__ + "static/media/channel-web.13e4f24d.svg";